export const SITE_NAME = '看料社';
export const SITE_FULL_NAME = '看料社 · 在线看料';
export const SITE_ORIGIN = 'https://z6933.cn';
export const SITE_TAGLINE = '高清不卡顿秒开，畅享极速超清';
export const SITE_INTRO =
  '看料社是一个聚合全网热门爆料、吃瓜现场与生活观察的极速超清观看门户，主打高清不卡顿的超流畅播放体验。';
export const CONTACT_EMAIL = 'hello@kanliaoshe.com';

export const navItems = [
  { label: '首页', to: '/', key: 'home' },
  { label: '内容分类', to: '/category', key: 'category' },
  { label: '关于我们', to: '/about', key: 'about' },
];

export const categoryNameMap: Record<string, string> = {
  all: '全部',
  hot: '热点突发',
  ent: '娱乐圈',
  society: '社会万象',
  tech: '科技前沿',
  life: '生活趣闻',
  talk: '影视解说',
};

export const sortOptions = [
  { id: 'hot', label: '最热', icon: 'ri-fire-line' },
  { id: 'new', label: '最新', icon: 'ri-time-line' },
  { id: 'duration', label: '时长', icon: 'ri-timer-line' },
];